import { VehicleModel, vehicleModelInitial } from './VehicleModel';

export interface VehicleBatchModel {
    vehicle: VehicleModel,
    classificationsId: number[]
}

export const vehicleBatchModelInitial: VehicleBatchModel = {
    vehicle: vehicleModelInitial,
    classificationsId: []
};